// @flow
import { connect } from 'react-redux';
import { State } from '../../../../types';
import zoneActions from '../../../../actions/zoneActions';
import { zonesConfigSelector } from '../../../../selectors/configSelectors';
import { drawingZoneSelector } from '../../../../selectors/zoneSelectors';
import ZoneList from '../ZoneList';
import type { Props } from '../ZoneList';

type OwnProps = $ReadOnly<{|
    list: $PropertyType<Props, 'list'>
|}>;

const mapStateToProps = (state: State) => {
    return {
        zonesConfig: zonesConfigSelector(state),
        drawingZone: drawingZoneSelector(state)
    };
};

const mapDispatchToProps = {
    enableDrawing: zoneActions.enableDrawingThunk,
    activateZones: zoneActions.activate,
    deactivateZones: zoneActions.deactivate,
    deleteZone: zoneActions.deleteZone
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(ZoneList);